// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
// import { FaAngleDown } from 'react-icons/fa'; // Arrow icon for dropdown
// import { FaEnvelope } from "react-icons/fa";

// const Header = () => {
//   const [expanded, setExpanded] = useState(false); // Track the navbar expansion state

//   const handleToggle = () => setExpanded(!expanded); // Toggle navbar on mobile

//   const handleNavItemClick = () => {
//     setExpanded(false); // Close the navbar on mobile after clicking a link
//   };

//   return (
//     <header className="main_header_area">
//       <div className="header_menu" id="header_menu">
//       <div className="header-top text-center" style={{
//       backgroundColor:"#35BE56"
//       }}>
//         <div className="auto-container">
//           <div className="inner-container bg-redd text-white py-md-2">
//             <div className="top-left">
//               <ul className="header-info list-unstyled mb-0 d-flex flex-column flex-md-row align-items-center">

// <li className="d-flex align-items-center mb-3 mb-md-0 me-md-4">
//   <a
//     href="tel:+919175577266"
//     className="d-block fw-bold text-white"
//   >
//     <i className="fas fa-phone-alt me-2 text-white"></i>
//     +91 9175577266
//   </a>
// </li>

// <li className="d-flex align-items-center mb-3 mb-md-0 ms-md-4">
//   <i className="fas fa-envelope me-2 text-white"></i>
//   <a
//     href="mailto:woodlandescape01@gmail.com"
//     className="d-block fw-bold text-white"
//   >
//     woodlandescape01@gmail.com
//   </a>
// </li>


//               </ul>
//             </div>
//           </div>
//         </div>
//       </div> 
// <li className="d-flex align-items-center mb-3 mb-md-0 me-md-4">
//   <a
//     href="tel:+919175577266"
//     className="d-block fw-bold text-white"
//   >
//     <i className="fas fa-phone-alt me-2 text-white"></i>
//     +91 9175577266
//   </a>
// </li>

// <li className="d-flex align-items-center mb-3 mb-md-0 ms-md-4">
//   <i className="fas fa-envelope me-2 text-white"></i>
//   <a
//     href="mailto:woodlandescape01@gmail.com"
//     className="d-block fw-bold text-white"
//   >
//     woodlandescape01@gmail.com
//   </a>
// </li>


//         <Navbar expanded={expanded} onToggle={handleToggle} bg="light" expand="lg">
//           <Container fluid>
//             <Navbar.Brand as={Link} to="/">
//               <img src="/images/logo.jpg" className='logoo' alt="Logo" />
//             </Navbar.Brand>
//             <Navbar.Toggle aria-controls="navbar-nav " className='borderr' />
//             <Navbar.Collapse id="navbar-nav" >
//               <Nav className="mx-auto navbarr">
//                 {/* Home Link */}
//                 <Nav.Item>
//                   <Nav.Link as={Link} to="/" onClick={handleNavItemClick} className='navbarr fw-bold'>Home</Nav.Link>
//                 </Nav.Item>

//                 <NavDropdown title={<><span className='navbarr fw-bold'> About-Us</span> <FaAngleDown className='navbarr fw-bold' /></>} id="contact-dropdown" drop="down">
//                   <NavDropdown.Item as={Link} to="/about" onClick={handleNavItemClick} className='navbarr fw-bold' >About</NavDropdown.Item>
//                   <NavDropdown.Item as={Link} to="/Term-condition" onClick={handleNavItemClick} className='navbarr fw-bold'>Terms and Conditions</NavDropdown.Item>
//                   <NavDropdown.Item as={Link} to="/Privacy-policy" onClick={handleNavItemClick} className='navbarr fw-bold'>Privacy Policy</NavDropdown.Item>
//                   <NavDropdown.Item as={Link} to="/Refund-policy" onClick={handleNavItemClick} className='navbarr fw-bold'>Refund Policy</NavDropdown.Item>
//                 </NavDropdown>



//                 {/* Attraction Dropdown */}
//                 {/* <NavDropdown 
//                   title={<><span className='navbarr fw-bold'>Attraction</span> <FaAngleDown className='navbarr'/></>} 
//                   id="attraction-dropdown" 
//                   drop="down"
//                   onClick={(e) => e.stopPropagation()} 
//                 >
//                   <NavDropdown.Item as={Link} to="/Attraction" onClick={handleNavItemClick} className='navbarr fw-bold'>
//                     Attraction
//                   </NavDropdown.Item>
//                   <NavDropdown.Item as={Link} to="/Near-by-Attractions" onClick={handleNavItemClick} className='navbarr fw-bold'>
//                   Nearby Places
//                   </NavDropdown.Item>

//                 </NavDropdown> */}
//                  <Nav.Item>
//                   <Nav.Link as={Link} to="/Near-by-Attractions" onClick={handleNavItemClick} className='navbarr fw-bold'>Nearby Places</Nav.Link>
//                 </Nav.Item>
//   <Nav.Item>
//                   <Nav.Link as={Link} to="/Activities" onClick={handleNavItemClick}className='navbarr fw-bold'>Features & Activities</Nav.Link>
//                 </Nav.Item>

//                 {/* Package Link */}
//                 <Nav.Item>
//                   <Nav.Link as={Link} to="/package" onClick={handleNavItemClick} className='navbarr fw-bold'>Package</Nav.Link>
//                 </Nav.Item>
//   <Nav.Item>
//                   <Nav.Link as={Link} to="/Online-booking" onClick={handleNavItemClick} className='navbarr fw-bold'>Online Booking</Nav.Link>
//                 </Nav.Item>
//                 {/* Gallery Link */}
                
//                 <NavDropdown title={<><span className='navbarr fw-bold'>Gallery </span> <FaAngleDown className='navbarr fw-bold' /></>} id="contact-dropdown" drop="down">
//                   <NavDropdown.Item as={Link} to="/gallery" onClick={handleNavItemClick}className='navbarr fw-bold'>Photo Gallery</NavDropdown.Item>
//                   <NavDropdown.Item as={Link} to="/videos" onClick={handleNavItemClick} className='navbarr fw-bold'>Video Gallery</NavDropdown.Item>
//                 </NavDropdown>
//                 {/* Nearby Places Link */}
              
              

//                 {/* Contact Us Dropdown */}
//                 <NavDropdown title={<><span className='navbarr fw-bold'>Contact Us</span> <FaAngleDown className='navbarr fw-bold' /></>} id="contact-dropdown" drop="down">
//                   <NavDropdown.Item as={Link} to="/contact" onClick={handleNavItemClick}className='navbarr fw-bold'>Contact</NavDropdown.Item>
//                   <NavDropdown.Item as={Link} to="/enquiry" onClick={handleNavItemClick} className='navbarr fw-bold'>Enquiry</NavDropdown.Item>
//                 </NavDropdown>
//               </Nav>
//             </Navbar.Collapse>
//           </Container>
//         </Navbar>
//       </div>
//     </header>
//   );
// };

// export default Header;



import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { FaAngleDown, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const Header = () => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => setExpanded(!expanded);
  const handleNavItemClick = () => setExpanded(false);

  return (
    <header className="main_header_area">
      <div className="header_menu" id="header_menu">

        {/* -------- TOP BAR -------- */}
        <div className="header-top text-center" style={{ backgroundColor: "#2F2256" }}>
          <div className="auto-container">
            <div className="inner-container text-white py-md-2">
              <div className="top-left">
                <ul className="header-info list-unstyled mb-0 d-flex flex-column flex-md-row align-items-center">

                  {/* PHONE */}
                  <li className="d-flex align-items-center mb-3 mb-md-0 me-md-4">
                    <FaPhoneAlt className="me-2 text-white" />
                    <a
                      href="tel:+9191755777266"
                      className="fw-bold text-white"
                    >
                      +91 9175577266
                    </a>
                  </li>

                  {/* EMAIL */}
                  <li className="d-flex align-items-center mb-3 mb-md-0 ms-md-4">
                    <FaEnvelope className="me-2 text-white" />
                    <a
                      href="mailto:woodlandescape01@gmail.com"
                      className="fw-bold text-white"
                    >
                      woodlandescape01@gmail.com
                    </a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* -------- MAIN NAVBAR -------- */}
        <Navbar expanded={expanded} onToggle={handleToggle} bg="light" expand="lg">
          <Container fluid>
            <Navbar.Brand as={Link} to="/">
              <img src="/images/logo.jpg" className='logoo' alt="Logo" />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="navbar-nav" className='borderr' />

            <Navbar.Collapse id="navbar-nav">
              <Nav className="mx-auto navbarr">

                <Nav.Item>
                  <Nav.Link as={Link} to="/" onClick={handleNavItemClick} className='navbarr fw-bold'>Experience</Nav.Link>
                </Nav.Item>

                {/* About Us */}
                <NavDropdown
                  title={<><span className='navbarr fw-bold'>Stay</span> <FaAngleDown /></>}
                  id="about-dropdown"
                >
                  <NavDropdown.Item as={Link} to="/rooms" onClick={handleNavItemClick} className='navbarr fw-bold'>Rooms</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/food" onClick={handleNavItemClick} className='navbarr fw-bold'>Foods</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/Term-condition" onClick={handleNavItemClick} className='navbarr fw-bold'>Terms & Conditions</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/Privacy-policy" onClick={handleNavItemClick} className='navbarr fw-bold'>Privacy Policy</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/Refund-policy" onClick={handleNavItemClick} className='navbarr fw-bold'>Refund Policy</NavDropdown.Item>
                </NavDropdown>

                <Nav.Item>
                  <Nav.Link as={Link} to="/Near-by-Attractions" onClick={handleNavItemClick} className='navbarr fw-bold'>Nearby Places</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link as={Link} to="/Activities" onClick={handleNavItemClick} className='navbarr fw-bold'>Features & Activities</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link as={Link} to="/package" onClick={handleNavItemClick} className='navbarr fw-bold'>Package</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link as={Link} to="/Online-booking" onClick={handleNavItemClick} className='navbarr fw-bold'>Online Booking</Nav.Link>
                </Nav.Item>

                <NavDropdown
                  title={<><span className='navbarr fw-bold'>Gallery</span> <FaAngleDown /></>}
                  id="gallery-dropdown"
                >
                  <NavDropdown.Item as={Link} to="/gallery" onClick={handleNavItemClick} className='navbarr fw-bold'>Photo Gallery</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/videos" onClick={handleNavItemClick} className='navbarr fw-bold'>Video Gallery</NavDropdown.Item>
                </NavDropdown>
<Nav.Item>
                  <Nav.Link as={Link} to="/goa-resort-coming-soon" onClick={handleNavItemClick} className='navbarr fw-bold'>Goa (Coming Soon)</Nav.Link>
                </Nav.Item>

                <NavDropdown
                  title={<><span className='navbarr fw-bold'>Contact Us</span> <FaAngleDown /></>}
                  id="contact-dropdown"
                >
                  <NavDropdown.Item as={Link} to="/contact" onClick={handleNavItemClick} className='navbarr fw-bold'>Contact</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/enquiry" onClick={handleNavItemClick} className='navbarr fw-bold'>Enquiry</NavDropdown.Item>
                </NavDropdown>

              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

      </div>
    </header>
  );
};

export default Header;
